



var ImageResizeMode={
center:'center',
contain:'contain',
cover:'cover',
none:'none',
repeat:'repeat',
stretch:'stretch'};


module.exports=ImageResizeMode;


// WEBPACK FOOTER //
// ./~/react-native-web/dist/components/Image/ImageResizeMode.js